import React, { Component } from "react";
import styled from "styled-components";
import { observer } from "mobx-react";
import { CaseManagementStore } from "Store";
import Header from "./header/HeaderWithStoreQuery";
import Filter from "./filter/FilterWithStore";
import List from "./list/ListWithStoreQuery";
import FilterDistribution from "./filter/FilterDistribution";

export default observer(
  class ListPanelWithStore extends Component {
    render() {
      const store = CaseManagementStore;
      const isPendingTab = store.selectedTab === "pending";
      const isMyCase = store.selectedTab === "my";
      return (
        <Wrapper>
          <Header />
          <FilterWrapper>
            {!isPendingTab && !isMyCase && <FilterDistribution />}
            {!isPendingTab && <Filter key="filter" store={store} />}
          </FilterWrapper>
          <List key="list" />
        </Wrapper>
      );
    }
  }
);

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 350px;
  border-right: 1px solid ${props => props.theme.panelBorder};
`;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
`;



// WEBPACK FOOTER //
// ./src/module-case-management/list-panel/ListPanelWithStore.js